import { PROTOCOL_TYPES } from '../Constants/AppConstants';

export const getListRfqGroupKey = (order) => (
  order.listId != null && String(order.listId).trim() !== ''
    && [PROTOCOL_TYPES.TRUMID_RFQ, PROTOCOL_TYPES.MARKETAXESS].includes(order.protocol)
    ? `${order.protocol}:${order.listId}` : null
);

// Use our internal list id: names and venue-assigned ids are not unique list keys.
export const groupListRfqOrders = (orders) => {
  const groups = new Map();
  const rows = [];

  orders.forEach((order, rowIndex) => {
    const key = getListRfqGroupKey(order);
    const entry = { order, rowIndex };
    if (!key) {
      rows.push(entry);
      return;
    }

    let group = groups.get(key);
    if (!group) {
      group = { key, listId: order.listId, listName: order.listName, protocol: order.protocol, orders: [] };
      groups.set(key, group);
      rows.push({ listGroup: group });
    }
    if (!group.listName?.trim() && order.listName?.trim()) group.listName = order.listName;
    group.orders.push(entry);
  });

  return rows;
};
